import { defineComponent, watch } from '@vue/runtime-core'
import { SlotScopeProperties, useMeta } from 'vue-meta'
import { useRouter } from 'vue-router'

import { WEBSITE_NAME } from '@/common/const'

export default defineComponent({
  name: 'VueMeta',
  setup () {
    const { meta } = useMeta({
      title: WEBSITE_NAME,
    })

    const router = useRouter()
    watch(router.currentRoute, () => {
      const route = router.currentRoute.value

      const htmlMeta = route.meta?.htmlMeta ?? true

      // true：使用 route.meta.title
      // false：由页面组件通过 useMeta 修改
      // object：更新
      if (htmlMeta === true) {
        meta.title = route.meta?.title || ''
      } else if (htmlMeta && htmlMeta !== false) {
        Object.assign(meta, htmlMeta)
      }
    })

    return () => {
      const slots = {
        title: ({ content }: SlotScopeProperties) => {
          return content ? `${content} - ${WEBSITE_NAME}` : WEBSITE_NAME
        },
      }

      return <metainfo v-slots={slots} />
    }
  },
})
